var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateItn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4168 6.41665H2.58351C2.58371 5.81454 2.58685 5.42526 2.62563 5.13697C2.66325 4.85732 2.72163 4.78718 2.75449 4.75431C2.78736 4.72144 2.8575 4.66307 3.13716 4.62545C3.43853 4.58491 3.85027 4.58331 4.50016 4.58331H12.5002C13.1501 4.58331 13.5618 4.58491 13.8632 4.62545C14.1428 4.66307 14.213 4.72144 14.2458 4.75431C14.2787 4.78718 14.3371 4.85732 14.3747 5.13697C14.4135 5.42526 14.4166 5.81454 14.4168 6.41665ZM14.4112 6.76687C14.4112 6.76689 14.4112 6.76657 14.4113 6.76593C14.4113 6.76598 14.4113 6.76603 14.4113 6.76608C14.4112 6.76659 14.4112 6.76685 14.4112 6.76687ZM2.75449 14.2456C2.72163 14.2128 2.66325 14.1426 2.62563 13.863C2.58509 13.5616 2.5835 13.1499 2.5835 12.5V9.24998H14.4168V12.5C14.4168 13.1499 14.4152 13.5616 14.3747 13.863C14.3371 14.1426 14.2787 14.2128 14.2458 14.2456C14.213 14.2785 14.1428 14.3369 13.8632 14.3745C13.5618 14.415 13.1501 14.4166 12.5002 14.4166H4.50016C3.85027 14.4166 3.43853 14.415 3.13716 14.3745C2.8575 14.3369 2.78736 14.2785 2.75449 14.2456Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16699 2.5V4.5V2.5ZM11.8337 2.5V4.5V2.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16699 2.5V4.5M11.8337 2.5V4.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateItn);
export default __webpack_public_path__ + "static/media/date-itn.fa42e85f187b364c6b247701c46a19bf.svg";
export { ForwardRef as ReactComponent };